var _excluded = ["viewBox"];
function cov_1a1nqpydfq() {
  var path = "/app/src/components/logo/components/logo-en-black-on-green-alshaya/logo-en-black-on-green-alshaya.tsx";
  var hash = "d606d1c9fa632f321822044373dc5b79f318bad5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-black-on-green-alshaya/logo-en-black-on-green-alshaya.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 41
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 10,
          column: 53
        }
      },
      "2": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 38,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 41
          },
          end: {
            line: 6,
            column: 42
          }
        },
        loc: {
          start: {
            line: 9,
            column: 17
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 23
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d606d1c9fa632f321822044373dc5b79f318bad5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1a1nqpydfq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1a1nqpydfq();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useSvgId } from 'src/hooks/use-svg-id';
cov_1a1nqpydfq().s[0]++;
export var LogoEnBlackOnGreenAlshaya = function LogoEnBlackOnGreenAlshaya(_ref) {
  var _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? (cov_1a1nqpydfq().b[0][0]++, '0 0 44 16') : _ref$viewBox,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1a1nqpydfq().f[0]++;
  var gradientId = (cov_1a1nqpydfq().s[1]++, useSvgId('paint0_linear_99_113'));
  cov_1a1nqpydfq().s[2]++;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "44",
    height: "16",
    rx: "3",
    fill: "url(#".concat(gradientId, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9652 5.27993L36.6925 13.8922H34.9618L35.5258 11.7736H33.9443L32.2467 5.28545H34.0991L35.57 11.6192L37.2289 5.28545V5.27993H38.9652ZM10.04 6.2013V4.97097L6.4126 5.52269C7.43557 5.30752 8.02171 4.49098 8.02171 3.67443V3.16685H6.18589V5.55579L5.17398 5.71579V6.94612L6.18589 6.79164V7.36542L5.17951 7.5199V8.69506L6.18589 8.54058V9.95298C6.24672 11.1833 7.05956 11.9171 8.39219 11.9171C8.86773 11.9171 9.34327 11.8178 9.78011 11.6302L9.79117 11.6247V10.0854L9.76905 10.0964C9.50916 10.2233 9.22162 10.2895 8.93409 10.2895C8.31477 10.2895 7.92218 10.1902 7.92218 9.68815V8.27024L10.0455 7.94473V6.76957L7.92218 7.09508V6.5213L10.04 6.2013ZM15.5032 5.56682L17.2395 5.302V11.7847H15.5032V9.72126C15.4369 11.095 14.5798 11.9116 13.1808 11.9116C12.379 11.9116 11.7155 11.6026 11.2676 11.0178C10.8197 10.433 10.5819 9.57781 10.5819 8.53506C10.5819 7.49232 10.8197 6.63716 11.2676 6.05234C11.7155 5.46752 12.379 5.15855 13.1808 5.15855C14.5798 5.15855 15.4369 5.96958 15.5032 7.33784V5.56682ZM15.5972 8.53506C15.5972 7.94473 15.4479 7.44266 15.1659 7.08405C14.8784 6.71991 14.4637 6.52681 13.9715 6.52681C12.9541 6.52681 12.3458 7.27715 12.3458 8.53506C12.3458 9.79298 12.9541 10.5323 13.9715 10.5323C14.9613 10.5323 15.5972 9.74884 15.5972 8.53506ZM24.909 8.53506C24.909 10.6481 23.9358 11.9116 22.2991 11.9116C20.9001 11.9116 20.043 11.1005 19.9766 9.72126V11.7847H18.2403V3.67995L19.9766 3.41513V7.33784C20.043 5.96958 20.9001 5.15855 22.2991 5.15855C23.9358 5.15855 24.909 6.42199 24.909 8.53506ZM23.1395 8.53506C23.1395 7.27715 22.5313 6.52681 21.5139 6.52681C21.0217 6.52681 20.607 6.71991 20.3195 7.08405C20.0375 7.43715 19.8882 7.93921 19.8882 8.53506C19.8882 9.74884 20.5241 10.5323 21.5139 10.5323C22.5313 10.5323 23.1395 9.78746 23.1395 8.53506ZM32.2412 8.53506C32.2412 10.6481 31.268 11.9116 29.6313 11.9116C28.2323 11.9116 27.3752 11.1005 27.3088 9.72126V11.7847H25.5781V3.67995L27.3144 3.41513V7.33784C27.3807 5.96958 28.2378 5.15855 29.6368 5.15855C31.268 5.15855 32.2467 6.42199 32.2412 8.53506ZM30.4718 8.53506C30.4718 7.27715 29.8635 6.52681 28.8461 6.52681C28.3539 6.52681 27.9392 6.71991 27.6517 7.08405C27.3697 7.43715 27.2204 7.93921 27.2204 8.53506C27.2204 9.74884 27.8563 10.5323 28.8461 10.5323C29.8635 10.5323 30.4718 9.78746 30.4718 8.53506Z",
    fill: "#131C26"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId,
    x1: "0",
    y1: "7.9998",
    x2: "44",
    y2: "7.9998",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  }))));
};